<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('dashInvTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('dashInvSubTitle')" class="pb-2"></span>
            </h1>
            <div class="row my-3 d-flex justify-content-end">
              <multiselect
                v-show="programsDropdown.length"
                v-model="programaSelectDropdown"
                :options="programsDropdown"
                :placeholder="$ml.get('selectProgram')"
                :searchable="true"
                label="name"
                :close-on-select="true"
                :show-labels="false"
                :allow-empty="false"
                :preselect-first="true"
                :multiple="false"
                class="mb-2"
              >
              </multiselect>

              <div class="col-12 pr-1 input-group">
                <multiselect
                  v-model="listFilterSelected"
                  :options="listFilter"
                  :searchable="false"
                  label="name"
                  :close-on-select="true"
                  :custom-label="nameFilter"
                  :show-labels="false"
                  :allow-empty="false"
                  :preselect-first="true"
                  :multiple="false"
                >
                </multiselect>
              </div>

              <div class="col-12 px-1 input-group">
                <input
                  class="form-control filterInput"
                  v-model="txtSearchUser"
                  :placeholder="$ml.get('user')"
                  aria-label="Search"
                  style="border-right: none"
                  @input="waitAPI"
                />
                <div class="input-group-append">
                  <div class="input-group-text" style="background-color: #fff">
                    <svg width="20" height="20">
                      <image
                        xlink:href="../../../../src/assets/icons/search_s.svg"
                        width="18"
                        height="18"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-3">
              <table>
                <thead>
                  <tr>
                    <th class="col-7" v-text="$ml.get('specialist')"></th>
                    <th class="col-7" v-text="$ml.get('program')"></th>
                    <th
                      class="col-7 d-none d-lg-flex"
                      v-text="$ml.get('date')"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="!itensConvite.length" class="loading">
                    <div v-if="loading" class="c-loader m-3"></div>
                    <h6
                      v-else
                      class="col d-flex justify-content-center p-3"
                      v-text="$ml.get('noInvitationAvailable')"
                    >
                      Nenhum Convite disponível
                    </h6>
                  </tr>
                  <tr
                    v-show="itensConvite.length"
                    v-for="(item, index) in itensConvite"
                    :key="index"
                  >
                    <td class="col-7 d-flex align-items-center">
                      <a class="a-link" v-text="item.username || item.email"></a
                      ><br />
                      <span
                        v-if="!item.username && !item.email"
                        class="text-muted small"
                      ></span>
                    </td>
                    <td
                      class="col-7 d-flex align-items-center"
                      v-text="item.program_name"
                    ></td>
                    <td class="col-5 align-items-center h-53 d-none d-lg-flex">
                      <span
                        v-if="item.status == 'revoked'"
                        class="text-muted small"
                      >
                        {{ $ml.get("revoked") }}
                        {{
                          $ml
                            .with(
                              $utils.formatData(item.updatedAt, $ml.get("ln"))
                            )
                            .get("ago")
                        }}</span
                      >
                      <span
                        v-if="item.status == 'pending'"
                        class="text-muted small"
                      >
                        {{ $ml.get("sentTo") }}
                        {{
                          $ml
                            .with(
                              $utils.formatData(item.createdAt, $ml.get("ln"))
                            )
                            .get("ago")
                        }}</span
                      >
                      <span
                        v-if="item.status == 'declined'"
                        class="text-muted small"
                      >
                        {{ $ml.get("declined") }}
                        {{
                          $ml
                            .with(
                              $utils.formatData(item.updatedAt, $ml.get("ln"))
                            )
                            .get("ago")
                        }}</span
                      >
                      <span
                        v-if="item.status == 'accepted'"
                        class="text-muted small"
                      >
                        {{ $ml.get("accepted") }}
                        {{
                          $ml
                            .with(
                              $utils.formatData(item.updatedAt, $ml.get("ln"))
                            )
                            .get("ago")
                        }}</span
                      >
                    </td>
                    <td
                      class="col-10 col-md-5 d-flex align-items-center justify-content-around h-53"
                    >
                      <span
                        v-if="item.status == 'pending'"
                        class="badge badge-warning py-1"
                        v-text="$ml.get('pending')"
                        >Pendente</span
                      >
                      <span
                        v-if="item.status == 'revoked'"
                        class="badge badge-danger p-1"
                        v-text="$ml.get('revoked')"
                        >Revogado</span
                      >
                      <span
                        v-if="item.status == 'declined'"
                        class="badge badge-danger p-1"
                        v-text="$ml.get('declined')"
                        >Recusado</span
                      >
                      <span
                        v-if="item.status == 'accepted'"
                        class="badge badge-success p-1"
                        v-text="$ml.get('participating')"
                        >Participando</span
                      >

                      <div class="col-2 d-flex align-self-center">
                        <img
                          v-if="['pending', 'accepted'].includes(item.status)"
                          @click="revokeInvite(item)"
                          class="pointer align-self-center"
                          src="../../../../src/assets/icons/trash-alt.svg"
                          width="16"
                          height="16"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-show="totalPages > 10 && !loading" class="p-3">
                <b-pagination
                  v-model="pageActive"
                  :total-rows="totalPages"
                  :per-page="10"
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')"
                  align="right"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>

        <!-- Cards do lado direito -->
        <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
          <section>
            <div class="card mb-3">
              <div class="card-header border-0 pb-0">
                <div class="d-flex flex-row">
                  <span v-text="$ml.get('whoDoYouWantInvite')"></span>
                </div>
                <img
                  class="img-support"
                  src="../../../assets/images/send.png"
                />
              </div>
              <div
                class="card-body footer-helper pb-0 d-flex flex-column justify-content-left"
              >
                <form>
                  <div class="row py-2">
                    <multiselect
                      v-model="optionSelected"
                      :options="listOptions"
                      :searchable="false"
                      label="name"
                      :close-on-select="true"
                      :custom-label="nameLang"
                      :show-labels="false"
                      :allow-empty="false"
                      :preselect-first="true"
                      :multiple="false"
                    >
                    </multiselect>
                  </div>
                  <div class="row py-2" v-show="optionSelected.id == 'person'">
                    <div class="col">
                      <input
                        type="text"
                        @keypress="removeId()"
                        v-model="email"
                        class="form-control"
                        :placeholder="$ml.get('userEmail')"
                      />
                      <transition name="fade">
                        <label
                          v-if="emailError"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                          >Campo obrigatório</label
                        >
                      </transition>
                    </div>
                  </div>
                  <div v-if="optionSelected.id === 'person'">
                    <div :class="['row', { 'py-2': !languageError }]">
                      <multiselect
                        v-model="languageOptionSelected"
                        :options="languageOptions"
                        :searchable="false"
                        label="name"
                        :close-on-select="true"
                        :custom-label="nameLang"
                        :show-labels="false"
                        :allow-empty="false"
                        :preselect-first="true"
                        :multiple="false"
                      >
                      </multiselect>
                    </div>
                    <div class="mb-2">
                      <transition name="fade">
                        <label
                          v-if="languageError"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                          >Campo obrigatório</label
                        >
                      </transition>
                    </div>
                  </div>
                  <selectProgram
                    :listProgram="listProgram"
                    @getPrograms="getPrograms"
                    ref="selectProgramComponent"
                  />
                </form>
              </div>
              <div class="p-3 d-flex flex-column justify-content-left">
                <button
                  @click="inviteProgram()"
                  :disabled="loadingBtn"
                  class="btn btn-lg btn-block"
                >
                  <Spinner v-show="loadingBtn" :mx5="false" />
                  <span v-show="!loadingBtn" v-text="$ml.get('invite')"></span>
                </button>
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-header card-chart-medium">
                <span v-text="$ml.get('invitationsSummary')"
                  >Convites enviados</span
                >
              </div>
              <div
                class="card-body card-chart-body pb-0 pt-1 d-flex flex-column justify-content-left"
              >
                <div class="row">
                  <div class="col-12 border-r-d mt-2 mb-2">
                    <span class="pb-1">{{ $ml.get("accepted") }}s</span>
                    <h6>{{ accepted_invitations }}</h6>
                  </div>
                  <div class="col-12 pl-3 mt-2 mb-2">
                    <span class="pb-1">{{ $ml.get("pending") }}s</span>
                    <h6>{{ pending_invitations }}</h6>
                  </div>
                </div>
                <hr class="w-100 m-0" />
                <div class="row">
                  <div class="col-12 border-r-d mt-2 mb-2">
                    <span class="pb-1">{{ $ml.get("declined") }}s</span>
                    <h6>{{ declined_invitations }}</h6>
                  </div>
                  <div class="col-12 pl-3 mt-2 mb-2">
                    <span class="pb-1">{{ $ml.get("revoked") }}s</span>
                    <h6>{{ revoked_invitations }}</h6>
                  </div>
                </div>
                <hr class="w-100 m-0" />
                <div class="row">
                  <div class="col-12 mt-3 mb-3" style="color: #730ba9">
                    <span class="pb-1">Total: {{ total_invitations }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-visitors">
              <div class="card-header card-chart-mini">
                <div class="d-flex flex-row">
                  <span v-text="$ml.get('suggestions')"></span>
                </div>
              </div>
              <div class="card-body">
                <div class="d-column flex-row">
                  <div class="loading d-flex">
                    <div v-if="loadingSeggestion" class="c-loader"></div>
                    <h6
                      v-else
                      v-show="!itensSugestions.length"
                      class="p-1"
                      v-text="$ml.get('noSuggestionsAvailable')"
                    >
                      Nenhuma sugestão disponível
                    </h6>
                  </div>

                  <div
                    v-for="(item, index) in itensSugestions"
                    :key="index"
                    :class="
                      'h-profile d-flex py-2 align-items-center ' +
                      (itensSugestions.length == index + 1 ? 'no' : '')
                    "
                  >
                    <div
                      class="position-relative align-self-center d-flex align-items-center align-self-center"
                    >
                      <object
                        width="42"
                        height="42"
                        class="rounded-circle img-m"
                        :data="item.avatar"
                        type="image/png"
                      >
                        <img
                          width="42"
                          height="42"
                          class="rounded-circle img-m"
                          src="../../../assets/images/default.png"
                          alt="Avatar"
                        />
                      </object>
                      <div v-show="item.verified" class="verify">
                        <img
                          src="../../../../src/assets/icons/badge-check.png"
                          width="16"
                          height="16"
                        />
                      </div>
                    </div>
                    <a class="pl-2 d-flex align-items-center link-block">
                      <div class="align-self-center">
                        <h3 v-text="item.username"></h3>
                        <p>
                          {{ item.score }}
                          <span v-text="$ml.get('points')"></span>
                        </p>
                      </div>
                      <div @click="addSuggestions(item)" class="add pointer">
                        <img
                          src="../../../../src/assets/icons/plus-circle.png"
                          width="16"
                          height="16"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";
import RankingService from "../../../services/ranking.service";
import selectProgram from "../../../components/selectProgram.vue";
import _ from "lodash";
export default {
  name: "Invitations",
  components: {
    selectProgram,
  },
  data() {
    return {
      programSelected: [],
      optionSelected: { name: "E-mail", id: "person" },
      languageOptionSelected: {
        name: this.$ml.get("selectLanguage"),
        id: "selectLanguage",
      },
      email: "",
      hackerId: "",
      emailError: false,
      languageError: false,
      programError: false,

      loading: true,
      loadingSeggestion: false,
      loadingBtn: false,

      listProgram: [],
      itensSugestions: [],
      listOptions: [
        { name: "E-mail", id: "person" },
        { name: "Top 10", id: "top10" },
        { name: "Top 50", id: "top50" },
        { name: "verifieds", id: "allverified" },
      ],
      languageOptions: [
        { name: "English", id: "en" },
        { name: "Português", id: "pt" },
        { name: "Español", id: "es" },
      ],

      txtSearchUser: "",
      listFilterSelected: [],
      listFilter: [
        { name: "all", id: "" },
        { name: "pending", id: "pending" },
        { name: "revoked", id: "revoked" },
        { name: "declined", id: "declined" },
        { name: "accepted", id: "accepted" },
      ],

      accepted_invitations: 0,
      declined_invitations: 0,
      pending_invitations: 0,
      revoked_invitations: 0,
      total_invitations: 0,

      pageActive: 1,
      totalPages: 1,
      itensConvite: [],

      programsDropdown: [],
      programaSelectDropdown: "",
    };
  },
  watch: {
    pageActive: function () {
      this.changeDados();
    },
    listFilterSelected: function () {
      this.changeDados();
    },
    programaSelectDropdown() {
      this.changeDados();
    },
  },
  mounted() {
    this.changeDados();
    this.changePrograms();
    this.changeSuggestions();
    this.loadInvitationsSummary();
    this.getListProgramInvite();
  },
  methods: {
    waitAPI: _.debounce(function () {
      this.changeDados();
    }, 500),

    getPrograms(data) {
      this.programSelected = data.listPrograms;
    },

    inviteProgram() {
      this.emailError = false;
      this.programError = false;
      this.languageError = false;
      if (this.email.length < 3 && this.optionSelected.id == "person") {
        this.emailError = true;
        return;
      }
      if (!this.programSelected.length) {
        this.programError = true;
        return;
      }

      let idsProgram = this.programSelected.map((choice) => choice._id);

      let invites = {
        program: idsProgram,
        hacker: this.email,
        type: this.optionSelected.id,
      };

      if (this.optionSelected.id === "person") {
        invites.language = this.languageOptionSelected.id;

        if (this.languageOptionSelected.id == "selectLanguage") {
          this.languageError = true;
          return;
        }
      }

      if (this.optionSelected.id != "person") {
        delete invites.hacker;
      }

      if (this.hackerId) {
        delete invites.hacker;
        invites.hackerId = this.hackerId;
      }

      this.loadingBtn = true;
      var self = this;

      ProgramService.postInvites(invites).then(
        () => {
          this.loadingBtn = false;
          this.hackerId = null;
          this.email = "";
          this.changeDados(1, 10);

          Swal.fire({
            icon: "success",
            title: self.$ml.get("invitationSent"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.$refs.selectProgramComponent.listProgramSelected = [];
        },
        (error) => {
          this.loadingBtn = false;
          this.hackerId = null;
          const splitMessage = error.response.data.message.split(": ");
          const errorType = splitMessage[1];

          if (errorType === "hacker_limit_exceeded") {
            return Swal.fire({
              icon: "info",
              text: self.$ml
                .with("program", this.programSelected[0].name)
                .get("invitationProgramLimitReached"),
              showConfirmButton: true,
            });
          }

          if (error.response.data.statusCode === 412) {
            console.log(self.$ml.get("companyNdaVerificationRequired"));
            Swal.fire({
              icon: "info",
              text: self.$ml.get("companyNdaVerificationRequired"),
              showConfirmButton: true,
            });

            return;
          }

          if (error.response.data.statusCode === 400) {
            Swal.fire({
              icon: "info",
              text: self.$ml.get("invalidEmail"),
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });
          }
        }
      );
    },

    nameLang({ name }) {
      if (name == "verifieds") {
        return `${this.$ml.get(name)}`;
      }
      return name;
    },

    nameFilter({ name }) {
      return `${this.$ml.get(name)}`;
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        _id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.listProgram.push(tag);
      this.value.push(tag);
    },

    changeDados() {
      let payload = "";

      this.loading = true;
      this.itensConvite = [];

      if (this.txtSearchUser) payload += `&username=${this.txtSearchUser}`;

      if (
        this.programaSelectDropdown &&
        this.programaSelectDropdown._id != "all"
      )
        payload += `&program=${this.programaSelectDropdown._id}`;

      if (this.listFilterSelected.id)
        payload += `&status=${this.listFilterSelected.id}`;

      ProgramService.getInvites(this.pageActive, 10, payload).then(
        (response) => {
          this.loading = false;
          this.itensConvite = response.data.items;
          let resp = response.data;
          this.totalPages = resp.total;
        },
        () => {
          this.totalPages = 0;
          this.loading = false;
        }
      );
    },

    changePrograms() {
      const pageActive = 1;
      const pageSize = 99;
      ProgramService.getProgram(
        "status=in_progress&type=private",
        pageActive,
        pageSize
      ).then((response) => {
        this.listProgram = response.data.items;
      });
    },

    changeSuggestions() {
      this.loadingSeggestion = true;
      RankingService.getRankingGeral(1, 3).then(
        (response) => {
          this.loadingSeggestion = false;
          this.itensSugestions = response.data.items;
        },
        () => {
          this.loadingSeggestion = false;
        }
      );
    },

    addSuggestions(hacker) {
      (this.optionSelected = { name: "E-mail", id: "person" }),
        (this.hackerId = hacker._id);
      this.email = hacker.username;
    },

    revokeInvite(invite) {
      var self = this;

      ProgramService.revokeInvitation(invite.invitation_id).then(
        (response) => {
          this.loading = false;
          if (response.data == "invitation revoked") {
            Swal.fire({
              icon: "success",
              title: self.$ml.get("invitationRevoked"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            this.changeDados();
          }
        },
        () => {
          this.loading = false;
        }
      );
    },
    removeId() {
      this.hackerId = null;
    },
    loadInvitationsSummary() {
      this.loading = true;

      ProgramService.getInvitationsSummary().then(
        (response) => {
          this.loading = false;
          this.accepted_invitations = response.data.accepted_invitations;
          this.declined_invitations = response.data.declined_invitations;
          this.pending_invitations = response.data.pending_invitations;
          this.revoked_invitations = response.data.revoked_invitations;
          this.total_invitations = response.data.total;
        },
        () => {
          this.loading = false;
        }
      );
    },

    async getListProgramInvite() {
      try {
        const { data } = await ProgramService.getListProgramInvite();
        this.programsDropdown = [
          { name: this.$ml.get("all"), _id: "all" },
          ...data,
        ];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.a-link {
  color: #730ba9;
}
.h-53 > .badge {
  width: 80px !important;
  min-width: 80px !important;
}
</style>
